import * as ROUTES from 'constants/routes'
import MenuIcon from '@mui/icons-material/Menu'
import { Menu, MenuItem, styled } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useAuth } from 'services/auth'
import { isOnPrem } from 'config'
import useFlagCondition from 'components/shared/useFlagCondition'

const StyledNavTopMenu = styled(Menu)({
  '& .MuiMenu-paper': {
    top: 48,
    width: 200,
  },

  '& a': {
    textDecoration: 'none',
  },
})

export const TopNavMenu = (): JSX.Element => {
  const { hasPermission, isInternalUser } = useAuth()
  const experimentPlanningEnabled = useFlagCondition('experimentPlanningEnabled')

  // Admin Tools is accessible to:
  // - Internal users in GCP environments
  // - All users in ON_PREM environments
  const adminToolsEnabled = isOnPrem || isInternalUser

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null)
  const handleClose = () => setMenuAnchor(null)

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        sx={{ mr: 2 }}
        onClick={(e) => setMenuAnchor(e.currentTarget)}
      >
        <MenuIcon />
      </IconButton>
      <StyledNavTopMenu
        keepMounted
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={handleClose}
      >
        {hasPermission('runs:read') && (
          <RouterLink to={ROUTES.RUNS}>
            <MenuItem onClick={handleClose}>Runs</MenuItem>
          </RouterLink>
        )}
        {hasPermission('cells:read') && (
          <RouterLink to={ROUTES.CELL_BROWSING}>
            <MenuItem onClick={handleClose}>Cell Browsing</MenuItem>
          </RouterLink>
        )}
        {hasPermission('cells:graph_visualization:read') && (
          <RouterLink to={ROUTES.CELL_VISUALIZATIONS}>
            <MenuItem onClick={handleClose}>Cell Visualization</MenuItem>
          </RouterLink>
        )}
        {isInternalUser && (
          <RouterLink to={ROUTES.LABEL_VET}>
            <MenuItem onClick={handleClose}>Vet Labels</MenuItem>
          </RouterLink>
        )}
        {hasPermission('runs:read') && experimentPlanningEnabled && (
          <RouterLink to={ROUTES.EXPERIMENT_PLANNING}>
            <MenuItem onClick={handleClose}>Experiment Planning</MenuItem>
          </RouterLink>
        )}
        {adminToolsEnabled && (
          <RouterLink to={ROUTES.ADMIN_TOOLS}>
            <MenuItem onClick={handleClose}>Admin Tools</MenuItem>
          </RouterLink>
        )}
        <RouterLink to={ROUTES.ABOUT}>
          <MenuItem onClick={handleClose}>About</MenuItem>
        </RouterLink>
      </StyledNavTopMenu>
    </>
  )
}

export default TopNavMenu
